import React from "react";
import Navbar from "../layout/Navbar";

const RaterNavbar = () => {
  return (
    <Navbar
      type="평가자"
      menus={[
        {
          name: "시험실",
          link: "/rater/examroom",
          className: "exam",
        },
      ]}
    />
  );
};

export default RaterNavbar;
